import { render } from "./BaseInfiniteGridTable.vue?vue&type=template&id=5d82658a&scoped=true"
import script from "./BaseInfiniteGridTable.vue?vue&type=script&lang=js"
export * from "./BaseInfiniteGridTable.vue?vue&type=script&lang=js"

import "./BaseInfiniteGridTable.vue?vue&type=style&index=0&id=5d82658a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d82658a"]])

export default __exports__